<template>
  <v-row
    justify="end"
    class="mr-0">
    <v-dialog
      dark
      persistent
      v-model="addItemDialog"
      max-width="1000px">
      <v-card
        :loading="loadingData">
        <v-card-title class="secondary">
          <span
            class="headline">
            {{ readOnly ? $t('general.view') : (dataForModal ? $t(translation + '.edit') : $t(translation + '.add')) }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                large
                icon
                v-bind="attrs"
                v-on="on"
                @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('tooltips.close') }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-on:submit.prevent>
              <!--Korisnika pomoći-->
              <v-row>
                <!--Naziv korisnika pomoći-->
                <v-col
                  class="py-0"
                  cols="6">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_receiver.name"
                    :disabled="isEmptyObject(form.cb_help_receiver) || loadingData || loading"
                    :label="$t(translation+'.helpReceiver.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--PIB korisnika pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_receiver.pin"
                    :disabled="isEmptyObject(form.cb_help_receiver) || loadingData || loading"
                    :label="$t(translation+'.helpReceiver.pin')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odaberi korisnika pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpReceiverChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--Sektor djelatnosti i vrsta korisnika pomoći-->
              <v-row>
                <!--Sektor djelatnosti-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_activity.name"
                    :disabled="isEmptyObject(form.cb_activity)  || loadingData || loading"
                    :label="$t(translation+'.activity')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir sektora djelatnosti-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbActivityChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
                <!--Vrsta korisnika pomoći-->
                <v-col
                  :cols="readOnly ? 6 :5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_user_type.name"
                    :disabled="isEmptyObject(form.cb_help_user_type) || loadingData || loading"
                    :label="$t(translation+'.helpUserType.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir Vrste korisnika pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpUserTypeChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--Mjera i odluka davaoca pomoći-->
              <v-row>
                <!--Naziv mjere pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_measure.name"
                    :disabled="isEmptyObject(form.cb_help_measure) || loadingData || loading"
                    :label="$t(translation+'.helpMeasure.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir mjere pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpMeasureChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
                <!--Broj odluke davaoca pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_provider_decision.number"
                    :disabled="isEmptyObject(form.cb_provider_decision) || loadingData || loading"
                    :label="$t(translation+'.providerDecision.number')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir Broa odluke davaoca pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbProviderDecisionChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--Cilj pomoći i podcilj pomoći-->
              <v-row>
                <!--Cilj pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_goal.name"
                    :disabled="isEmptyObject(form.cb_help_goal) || loadingData || loading"
                    :label="$t(translation+'.helpGoal.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir cilja pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpGoalChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
                <!--Podcilj pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_sub_goal.name"
                    :disabled="isEmptyObject(form.cb_help_sub_goal) || loadingData || loading"
                    :label="$t(translation+'.helpSubGoal.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir podcilja pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpSubGoalChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>

              </v-row>
              <!-- Instrument pomoći i odluka agencije -->
              <v-row>
                <!--Instrument pomoći-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_instrument.name"
                    :disabled="isEmptyObject(form.cb_help_instrument) || loadingData || loading"
                    :label="$t(translation+'.helpInstrument.name')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir instrumenta pomoći-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbHelpInstrumentChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
                <!--Odluka agencije-->
                <v-col
                  :cols="readOnly ? 6 : 5"
                  class="pr-1 py-0">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_agency_decision.number"
                    :disabled="isEmptyObject(form.cb_agency_decision) || loadingData || loading"
                    :label="$t(translation+'.agencyDecision.number')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Odabir odluke agencije-->
                <v-col
                  v-if="!readOnly"
                  cols="1"
                  class="pl-1 py-0">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="info py-5"
                        dark
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogCbAgencyDecisionChooseItem()"
                      >
                        <v-icon>mdi-archive-arrow-up</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!-- Ukupan iznos pomoči i datum dodjele pomoći -->
              <v-row>
                <!--Ukupan iznos pomoći-->
                <v-col
                  class="py-0"
                  cols="6">
                  <v-text-field
                    class="my-1 py-1"
                    :key="totalKey"
                    v-model="form.total"
                    :rules="rules.gt_zero_lte_800k"
                    :label="$t(translation + '.total_input')"
                    v-money="moneyFloat"
                    hide-details
                    required
                    :readonly="readOnly"
                  />
                </v-col>
                <!--Datum dodjele pomoći-->
                <v-col
                  cols="6"
                  class="pr-5 py-0">
                  <v-menu
                    v-model="dateMenuDateFrom"
                    dark
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="my-1 py-1"
                        v-model="form.date_awarded"
                        dark
                        :label="$t(translation+'.date_awarded')+'*'" required
                        :rules="rules.required"
                        readonly
                        v-bind="attrs"
                        v-on="readOnly ? null : on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.date_awarded"
                      dark
                      @input="dateMenuDateFrom = false"
                      :max="new Date().toISOString().slice(0,10)"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <!--Davalac, status i datum objave pomoći-->
              <v-row>
                <!--Davalac pomoći-->
                <v-col
                  class="py-0"
                  :cols="9">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_provider.name"
                    :label="$t(translation+'.helpProvider.name')+'*'" required
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Status pomoći-->
                <v-col
                  class="py-0"
                  :cols="3">
                  <v-text-field
                    class="my-1 py-1"
                    v-model="form.cb_help_status.name"
                    :label="$t(translation+'.helpStatus.name')+'*'" required
                    autocomplete="off"
                    readonly
                  />
                </v-col>
                <!--Datum objave pomoći-->
<!--                <v-col-->
<!--                  cols="3"-->
<!--                  class="pr-5 py-0">-->
<!--                  <v-menu-->
<!--                    v-model="dateMenuDateTo"-->
<!--                    dark-->
<!--                    :close-on-content-click="false"-->
<!--                    transition="scale-transition"-->
<!--                    offset-y-->
<!--                    min-width="auto"-->
<!--                  >-->
<!--                    <template v-slot:activator="{ on, attrs }">-->
<!--                      <v-text-field-->
<!--                        class="my-1 py-1"-->
<!--                        v-model="form.date_to"-->
<!--                        dark-->
<!--                        :label="$t(translation+'.date_to')+'*'" required-->
<!--                        :rules="rules.required"-->
<!--                        readonly-->
<!--                        v-bind="attrs"-->
<!--                        v-on="readOnly ? null : on"-->
<!--                      ></v-text-field>-->
<!--                    </template>-->
<!--                    <v-date-picker-->
<!--                      v-model="form.date_to"-->
<!--                      dark-->
<!--                      @input="dateMenuDateTo = false"-->
<!--                    ></v-date-picker>-->
<!--                  </v-menu>-->
<!--                </v-col>-->
              </v-row>
              <!--Komentar-->
              <v-row v-if="form.cb_help_status_id === 2">
                <v-col
                  class="py-0"
                  cols="12">
                  <v-textarea
                    class="my-0 py-0"
                    v-model="form.comment"
                    :label="$t(translation+'.comment')+'*'"
                    :rules="rules.required"
                    rows="3"
                    dark
                    outlined
                    required
                    readonly
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{ $t('required_fields') }}</small>
        </v-card-text>
        <v-card-actions
        v-if="!readOnly"
        >
          <div
            class="flex-grow-1">
          </div>
          <v-btn
            class="info mr-2"
            dark
            :loading="loading"
            @click="addEdit()"
          >
            {{ dataForModal ? $t('edit') : $t('add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Choose cb_help_receiver item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpReceiverChooseDialog.showDialog"
      :singleSelect="cbHelpReceiverChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpReceiverChooseDialog.translation"
      :api="cbHelpReceiverChooseDialog.apiRead"
      :show-columns="cbHelpReceiverChooseDialog.showColumns"
      :headers="cbHelpReceiverChooseItemHeaders"
      :additional-parameters="cbHelpReceiverChooseDialog.additionalParameters"
      @closeChooseItemDialog="cbHelpReceiverChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpReceiverChosenEvent"
    />
    <!---------------------------------- Choose cb_help_measure item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpMeasureChooseDialog.showDialog"
      :singleSelect="cbHelpMeasureChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpMeasureChooseDialog.translation"
      :api="cbHelpMeasureChooseDialog.apiRead"
      :show-columns="cbHelpMeasureChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpMeasureChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpMeasureChosenEvent"
    />
    <!---------------------------------- Choose cb_agency_decision item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="900"
      :dialogChooseItem="cbAgencyDecisionChooseDialog.showDialog"
      :singleSelect="cbAgencyDecisionChooseDialog.singleSelect"
      :id="null"
      :translation="cbAgencyDecisionChooseDialog.translation"
      :api="cbAgencyDecisionChooseDialog.apiRead"
      :show-columns="cbAgencyDecisionChooseDialog.showColumns"
      :headers="cbAgencyDecisionChooseItemHeaders"
      sort-by-column="number"
      @closeChooseItemDialog="cbAgencyDecisionChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbAgencyDecisionChosenEvent"
    />
    <!---------------------------------- Choose cb_provider_decision item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbProviderDecisionChooseDialog.showDialog"
      :singleSelect="cbProviderDecisionChooseDialog.singleSelect"
      :id="null"
      :additional-parameters="{cb_help_category_id: 3}"
      :translation="cbProviderDecisionChooseDialog.translation"
      :api="cbProviderDecisionChooseDialog.apiRead"
      :show-columns="cbProviderDecisionChooseDialog.showColumns"
      :headers="cbProviderDecisionChooseItemHeaders"
      sort-by-column="number"
      @closeChooseItemDialog="cbProviderDecisionChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbProviderDecisionChosenEvent"
    />
    <!---------------------------------- Choose cb_help_type item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpTypeChooseDialog.showDialog"
      :singleSelect="cbHelpTypeChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpTypeChooseDialog.translation"
      :api="cbHelpTypeChooseDialog.apiRead"
      :show-columns="cbHelpTypeChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpTypeChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpTypeChosenEvent"
    />
    <!---------------------------------- Choose cb_help_user_type item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpUserTypeChooseDialog.showDialog"
      :singleSelect="cbHelpUserTypeChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpUserTypeChooseDialog.translation"
      :api="cbHelpUserTypeChooseDialog.apiRead"
      :show-columns="cbHelpUserTypeChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpUserTypeChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpUserTypeChosenEvent"
    />
    <!---------------------------------- Choose cb_activity item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbActivityChooseDialog.showDialog"
      :singleSelect="cbActivityChooseDialog.singleSelect"
      :id="null"
      :translation="cbActivityChooseDialog.translation"
      :api="cbActivityChooseDialog.apiRead"
      :show-columns="cbActivityChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbActivityChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbActivityChosenEvent"
    />
    <!---------------------------------- Choose cb_help_goal item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpGoalChooseDialog.showDialog"
      :singleSelect="cbHelpGoalChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpGoalChooseDialog.translation"
      :api="cbHelpGoalChooseDialog.apiRead"
      :show-columns="cbHelpGoalChooseDialog.showColumns"
      :additional-parameters="{
        cb_help_category_id: 3 //3 - GENERAL
      }"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpGoalChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpGoalChosenEvent"
    />
    <!---------------------------------- Choose cb_help_sub_goal item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpSubGoalChooseDialog.showDialog"
      :singleSelect="cbHelpSubGoalChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpSubGoalChooseDialog.translation"
      :api="cbHelpSubGoalChooseDialog.apiRead"
      :show-columns="cbHelpSubGoalChooseDialog.showColumns"
      :additional-parameters="{
        cb_help_goal_id: this.form.cb_help_goal_id
      }"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpSubGoalChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpSubGoalChosenEvent"
    />
    <!---------------------------------- Choose cb_help_instrument item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpInstrumentChooseDialog.showDialog"
      :singleSelect="cbHelpInstrumentChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpInstrumentChooseDialog.translation"
      :api="cbHelpInstrumentChooseDialog.apiRead"
      :show-columns="cbHelpInstrumentChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpInstrumentChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpInstrumentChosenEvent"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import {add, edit, isEmptyObject} from "../../../statics/DataTableFunctions";
import ChooseItemDialog from "../../user/ChooseItemDialog";
import moment from "moment";
import axios from "axios";

export default {
  props: {
    addItemDialog: false,
    dataForModal: null,
    readOnly: {
      default: false,
      type: Boolean
    },
  },
  components: {
    'dialog-choose-item': ChooseItemDialog
  },
  name: "AddEditHelpRegistriesGeneral",
  data() {
    return {
      translation: 'help_registries.general',
      apiObject: '/api/help_registries/general/object',
      apiAdd: '/api/help_registries/general/store',
      apiEdit: '/api/help_registries/general/update',
      loading: false,
      loadingData: false,
      dateMenuDateFrom: false,
      dateMenuDateTo: false,
      totalKey: 0,
      form: {
        total: 0,
        date_awarded: null,
        // date_to: moment().format('YYYY-MM-DD'),
        date_to: null,
        comment: null,
        cb_help_receiver: {},
        cb_help_receiver_id: null,
        cb_help_measure: {},
        cb_help_measure_id: null,
        cb_agency_decision: {},
        cb_agency_decision_id: null,
        cb_provider_decision: {},
        cb_provider_decision_id: null,
        cb_help_type: {},
        cb_help_type_id: null,
        cb_help_user_type: {},
        cb_help_user_type_id: null,
        cb_activity: {},
        cb_activity_id: null,
        cb_help_goal: {},
        cb_help_goal_id: null,
        cb_help_sub_goal: {},
        cb_help_sub_goal_id: null,
        cb_help_instrument: {},
        cb_help_instrument_id: null,
        cb_help_provider: {},
        cb_help_provider_id: null,
        cb_help_status: {},
        cb_help_status_id: null
      },
      moneyFloat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' €',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      rules: {
        required: [
          v => !!v || this.$t('validation.field')
        ],
        gt_zero_lte_800k: [
          v => !!v || this.$t('validation.field'),
          v => this.isTotalValid(v) || this.$t('validation.field'),
        ],
        required_length: [
          v => !!v || this.$t('validation.field'),
          v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
        ],
      },
      show_columns: [
        "id",
        "total",
        "date_awarded",
        "date_to",
        "comment",
        "is_active",
        "cb_help_measure_id",
        "cb_agency_decision_id",
        "cb_help_receiver_id",
        "cb_help_user_type_id",
        "cb_activity_id",
        "cb_help_provider_id",
        "cb_help_status_id",
        "cb_provider_decision_id",
        "cb_help_type_id",
        "cb_help_goal_id",
        "cb_help_sub_goal_id",
        "cb_help_instrument_id",
      ],
      show_columns_cb_help_measure_relation: [
        "id",
        "name"
      ],
      show_columns_cb_agency_decision_relation: [
        "id",
        "number"
      ],
      show_columns_cb_help_receiver_relation: [
        "id",
        "name",
        "pin"
      ],
      show_columns_cb_help_user_type_relation: [
        "id",
        "name"
      ],
      show_columns_cb_activity_relation: [
        "id",
        "name"
      ],
      show_columns_cb_help_provider_relation: [
        "id",
        "name"
      ],
      show_columns_cb_help_status_relation: [
        "id",
        "name"
      ],
      show_columns_cb_provider_decisions_relation: [
        "id",
        "number"
      ],
      show_columns_cb_help_type_relation: [
        "id",
        "name"
      ],
      show_columns_cb_help_goal_relation: [
        "id",
        "name"
      ],
      show_columns_cb_help_sub_goal_relation: [
        "id",
        "name"
      ],
      show_columns_cb_help_instrument_relation: [
        "id",
        "name"
      ],
      cbHelpReceiverChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_receivers',
        apiRead: '/api/cb_help_receivers/index',
        showColumns: [
          "id",
          "name",
          "pin",
          "cb_activity_id",
          "cb_help_user_type_id"
        ],
        additionalParameters: {
          show_columns_cb_help_user_type_relation: [
            "id",
            "name"
          ],
          show_columns_cb_activity_relation: [
            "id",
            "name"
          ]
        }
      },
      cbHelpMeasureChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_measures',
        apiRead: '/api/cb_help_measures/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbAgencyDecisionChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.agency_decisions',
        apiRead: '/api/cb_agency_decisions/index',
        showColumns: [
          "id",
          "name",
          "number",
          "date",
        ],
      },
      cbProviderDecisionChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.provider_decisions',
        apiRead: '/api/cb_provider_decisions/index',
        showColumns: [
          "id",
          "number",
        ],
      },
      cbHelpTypeChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_types',
        apiRead: '/api/cb_help_types/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbHelpUserTypeChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_user_types',
        apiRead: '/api/cb_help_user_types/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbActivityChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.activities',
        apiRead: '/api/cb_activities/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbHelpGoalChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_goals',
        apiRead: '/api/cb_help_goals/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbHelpSubGoalChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_sub_goals',
        apiRead: '/api/cb_help_sub_goals/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbHelpInstrumentChooseDialog: {
        showDialog: false,
        singleSelect: true,
        translation: 'cb.help_instruments',
        apiRead: '/api/cb_help_instruments/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },
    }
  },
  methods: {
    add,
    edit,
    isEmptyObject,
    checkIfHelpReceiverIsChosen() {
      if (this.form.cb_help_receiver_id === null) {
        this.$swal.fire({
          type: 'warning',
          title: "Info",
          text: 'Morate odabrati korisnika pomoći',
        })
        return false;
      }
      return true;
    },
    openDialogCbHelpReceiverChooseItem() {
      this.cbHelpReceiverChooseDialog.showDialog = true;
    },
    openDialogCbAgencyDecisionChooseItem() {
      this.cbAgencyDecisionChooseDialog.showDialog = true;
    },
    openDialogCbHelpMeasureChooseItem() {
      this.cbHelpMeasureChooseDialog.showDialog = true;
    },
    openDialogCbProviderDecisionChooseItem() {
      this.cbProviderDecisionChooseDialog.showDialog = true;
    },
    openDialogCbHelpTypeChooseItem() {
      this.cbHelpTypeChooseDialog.showDialog = true;
    },
    openDialogCbHelpUserTypeChooseItem() {
      if (this.checkIfHelpReceiverIsChosen()) {
        this.cbHelpUserTypeChooseDialog.showDialog = true;
      }
    },
    openDialogCbActivityChooseItem() {
      if (this.checkIfHelpReceiverIsChosen()) {
        this.cbActivityChooseDialog.showDialog = true;
      }
    },
    openDialogCbHelpGoalChooseItem() {
      this.cbHelpGoalChooseDialog.showDialog = true;
    },
    openDialogCbHelpSubGoalChooseItem() {
      if(!this.form.cb_help_goal_id) {
        this.$swal.fire({
          type: 'error',
          title: "Info",
          text: 'Morate odabrati cilj pomoći',
        })
        return;
      }
      this.cbHelpSubGoalChooseDialog.showDialog = true;
    },
    openDialogCbHelpInstrumentChooseItem() {
      this.cbHelpInstrumentChooseDialog.showDialog = true;
    },
    onItemCbHelpReceiverChosenEvent(item) {
      this.form.cb_help_receiver = item;
      this.form.cb_help_receiver_id = item.id;
      this.form.cb_activity = item.cb_activity;
      this.form.cb_activity_id = item.cb_activity.id;
      this.form.cb_help_user_type = item.cb_help_user_type;
      this.form.cb_help_user_type_id = item.cb_help_user_type.id;
      this.cbHelpReceiverChooseDialog.showDialog = false;
    },
    onItemCbHelpMeasureChosenEvent(item) {
      this.form.cb_help_measure = item;
      this.form.cb_help_measure_id = item.id;
      this.cbHelpMeasureChooseDialog.showDialog = false;
    },
    onItemCbAgencyDecisionChosenEvent(item) {
      this.form.cb_agency_decision = item;
      this.form.cb_agency_decision_id = item.id;
      this.cbAgencyDecisionChooseDialog.showDialog = false;
    },
    onItemCbProviderDecisionChosenEvent(item) {
      this.form.cb_provider_decision = item;
      this.form.cb_provider_decision_id = item.id;
      this.cbProviderDecisionChooseDialog.showDialog = false;
    },
    onItemCbHelpTypeChosenEvent(item) {
      this.form.cb_help_type = item;
      this.form.cb_help_type_id = item.id;
      this.cbHelpTypeChooseDialog.showDialog = false;
    },
    onItemCbHelpUserTypeChosenEvent(item) {
      this.form.cb_help_user_type = item;
      this.form.cb_help_user_type_id = item.id;
      this.cbHelpUserTypeChooseDialog.showDialog = false;
    },
    onItemCbActivityChosenEvent(item) {
      this.form.cb_activity = item;
      this.form.cb_activity_id = item.id;
      this.cbActivityChooseDialog.showDialog = false;
    },
    onItemCbHelpGoalChosenEvent(item) {
      if(this.form.cb_help_goal_id !== item.id) {
        this.form.cb_help_goal = item;
        this.form.cb_help_goal_id = item.id;

        this.form.cb_help_sub_goal = {};
        this.form.cb_help_sub_goal_id = null;
      }
      this.cbHelpGoalChooseDialog.showDialog = false;
    },
    onItemCbHelpSubGoalChosenEvent(item) {
      this.form.cb_help_sub_goal = item;
      this.form.cb_help_sub_goal_id = item.id;
      this.cbHelpSubGoalChooseDialog.showDialog = false;
    },
    onItemCbHelpInstrumentChosenEvent(item) {
      this.form.cb_help_instrument = item;
      this.form.cb_help_instrument_id = item.id;
      this.cbHelpInstrumentChooseDialog.showDialog = false;
    },
    closeDialog() {
      this.totalKey = 0;
      this.form = {
        total: 0,
        date_awarded: null,
        date_to: null,
        comment: null,
        cb_help_receiver: {},
        cb_help_receiver_id: null,
        cb_help_measure: {},
        cb_help_measure_id: null,
        cb_agency_decision: {},
        cb_agency_decision_id: null,
        cb_provider_decision: {},
        cb_provider_decision_id: null,
        cb_help_type: {},
        cb_help_type_id: null,
        cb_help_user_type: {},
        cb_help_user_type_id: null,
        cb_activity: {},
        cb_activity_id: null,
        cb_help_goal: {},
        cb_help_goal_id: null,
        cb_help_sub_goal: {},
        cb_help_sub_goal_id: null,
        cb_help_instrument: {},
        cb_help_instrument_id: null,
        cb_help_provider: {},
        cb_help_provider_id: null,
        cb_help_status: {},
        cb_help_status_id: null
      }
      this.$refs.form.resetValidation()
      this.$emit('close')
    },
    onResponseFunction(response) {
      this.$emit(this.dataForModal ? 'editEmit' : 'addEmit', response.data);
      this.closeDialog();
      this.snackbar.color = 'success';
      this.snackbar.text = this.$t(this.dataForModal ? 'edit_success' : 'add_success');
      this.snackbar.show = true;
      this.loading = false;
    },
    onErrorFunction(error) {
      if (error.response.status === 401) {
        this.loading = false
        this.$swal.fire({
          type: 'info',
          title: "Info",
          text: this.$t('validation.session'),
        })
        this.$router.push('/login')
      } else {
        this.loading = false
        this.$swal.fire({
          type: 'error',
          title: this.$t('validation.error'),
          text: error.response.data.message,
        })
      }
    },
    addEdit() {
      if (!this.$refs.form.validate()) {
        this.snackbar.color = 'error';
        this.snackbar.text = this.$t('snackbar_required');
        this.snackbar.show = true;
        return;
      }

      let data = {...this.form};
      data.total = this.parseVmoneyValue(this.form.total);

      this.loading = true;
      const axiosRequest = this.dataForModal ? axios.put(this.apiEdit + "/" + data.id, data) : axios.post(this.apiAdd, data);

      axiosRequest
        .then((response) => this.onResponseFunction(response))
        .catch(error => this.onErrorFunction(error))
    },
    setHelpProviderAndStatus() {
      const cbHelpProvider = JSON.parse(localStorage.getItem('cb_help_provider'));
      this.form.cb_help_provider = cbHelpProvider ? cbHelpProvider : {};
      this.form.cb_help_provider_id = cbHelpProvider ? cbHelpProvider.id : null;
      this.form.cb_help_status = {
        id: 3,
        name: "Unijeta u registar"
      }
      this.form.cb_help_status_id = this.form.cb_help_status.id;
    },
    parseVmoneyValue(val) {
      return parseFloat(val.toString().replaceAll(".", "").replace(",", ".").replace(this.moneyFloat.suffix, ""))
    },
    isTotalValid(value) {
      const total = this.parseVmoneyValue(value);
      return total > 0 && total <= 800000;
    },
    readObjectData(id) {
      this.loadingData = true;
      axios.post(this.apiObject + "/" + id, {
        show_columns: this.show_columns,
        show_columns_cb_help_measure_relation: this.show_columns_cb_help_measure_relation,
        show_columns_cb_agency_decision_relation: this.show_columns_cb_agency_decision_relation,
        show_columns_cb_help_receiver_relation: this.show_columns_cb_help_receiver_relation,
        show_columns_cb_help_user_type_relation: this.show_columns_cb_help_user_type_relation,
        show_columns_cb_activity_relation: this.show_columns_cb_activity_relation,
        show_columns_cb_help_provider_relation: this.show_columns_cb_help_provider_relation,
        show_columns_cb_help_status_relation: this.show_columns_cb_help_status_relation,
        show_columns_cb_provider_decisions_relation: this.show_columns_cb_provider_decisions_relation,
        show_columns_cb_help_type_relation: this.show_columns_cb_help_type_relation,
        show_columns_cb_help_goal_relation: this.show_columns_cb_help_goal_relation,
        show_columns_cb_help_sub_goal_relation: this.show_columns_cb_help_sub_goal_relation,
        show_columns_cb_help_instrument_relation: this.show_columns_cb_help_instrument_relation
      }).then(response => {
        this.form = {
          id: response.data.id,
          total: response.data.total,
          date_awarded: response.data.date_awarded,
          // date_to: response.data.date_to,
          comment: response.data.comment,
          cb_help_receiver: response.data.cb_help_receiver,
          cb_help_receiver_id: response.data.cb_help_receiver ? response.data.cb_help_receiver.id : null,
          cb_help_measure: response.data.cb_help_measure,
          cb_help_measure_id: response.data.cb_help_measure ? response.data.cb_help_measure.id : null,
          cb_agency_decision: response.data.cb_agency_decision,
          cb_agency_decision_id: response.data.cb_agency_decision ? response.data.cb_agency_decision.id : null,
          cb_provider_decision: response.data.cb_provider_decision,
          cb_provider_decision_id: response.data.cb_provider_decision ? response.data.cb_help_measure.id : null,
          cb_help_type: response.data.cb_help_type,
          cb_help_type_id: response.data.cb_help_type ? response.data.cb_help_type.id : null,
          cb_help_user_type: response.data.cb_help_user_type,
          cb_help_user_type_id: response.data.cb_help_user_type ? response.data.cb_help_user_type.id : null,
          cb_activity: response.data.cb_activity,
          cb_activity_id: response.data.cb_activity ? response.data.cb_activity.id : null,
          cb_help_goal: response.data.cb_help_goal,
          cb_help_goal_id: response.data.cb_help_goal ? response.data.cb_help_goal.id : null,
          cb_help_sub_goal: response.data.cb_help_sub_goal,
          cb_help_sub_goal_id: response.data.cb_help_sub_goal ? response.data.cb_help_sub_goal.id : null,
          cb_help_instrument: response.data.cb_help_instrument,
          cb_help_instrument_id: response.data.cb_help_instrument ? response.data.cb_help_instrument.id : null,
          cb_help_provider: response.data.cb_help_provider,
          cb_help_provider_id: response.data.cb_help_provider ? response.data.cb_help_provider.id : null,
          cb_help_status: response.data.cb_help_status,
          cb_help_status_id: response.data.cb_help_status ? response.data.cb_help_status.id : null
        }
        this.totalKey++;
        this.loadingData = false;
      }).catch(error => {
        this.loadingData = false
        if (error.response.status === 401) {
          this.loading = false
          this.$swal.fire({
            type: 'info',
            title: "Info",
            text: this.$t('validation.session'),
          })
          this.$router.push('/login')
        } else {
          this.$swal.fire({
            type: 'error',
            title: this.$t('validation.error'),
            text: this.$t('validation.error'),
          })
        }
      });
    },
  },

  computed: {
    cbHelpReceiverChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.pin'),
          name: 'pin',
          align: 'left',
          value: 'pin'
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        }
      ]
    },
    cbChooseItemHeaderName() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
      ]
    },
    cbProviderDecisionChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbProviderDecisionChooseDialog.translation + '.number'),
          name: 'number',
          align: 'left',
          value: 'number'
        },
      ]
    },
    cbAgencyDecisionChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbAgencyDecisionChooseDialog.translation + '.number'),
          name: 'number',
          align: 'left',
          value: 'number'
        },
        {
          text: this.$t(this.cbAgencyDecisionChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t(this.cbAgencyDecisionChooseDialog.translation + '.date'),
          name: 'date',
          align: 'left',
          value: 'date'
        },
      ]
    },
  },
  watch: {
    addItemDialog: function (val) {
      if (val && !this.dataForModal) {
        this.setHelpProviderAndStatus();
        this.form.total = 0;
        this.totalKey++;
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 1)
      }
    },
    dataForModal: function (val) {
      if (val) {
        this.readObjectData(this.dataForModal.id);
      }
    }
  },
  created() {
    this.totalKey++;
    this.setHelpProviderAndStatus();
  }
}
</script>

<style scoped/>
